import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';
import { Observable } from 'rxjs/Observable';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class PublicEnquiryService {

    constructor(
        private http: HttpService
    ) { }

    getList() {
        const param = new HttpParams()
            .set('pageNumber', '1')
            .set('pageSize', '10');
        return this.http.get('api/open/inquiryPublicList', { params: param })
            .switchMap(res => this.http.mapRes(res));
    }

    getList5() {
        const param = new HttpParams()
            .set('pageNumber', '1')
            .set('pageSize', '5');
        return this.http.get('api/open/inquiryPublicList', { params: param })
            .switchMap(res => this.http.mapRes(res));
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/public-enquiry.service.ts